import { render, staticRenderFns } from "./NoInviteesView.vue?vue&type=template&id=6d24cec3&"
import script from "./NoInviteesView.vue?vue&type=script&lang=js&"
export * from "./NoInviteesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d24cec3')) {
      api.createRecord('6d24cec3', component.options)
    } else {
      api.reload('6d24cec3', component.options)
    }
    module.hot.accept("./NoInviteesView.vue?vue&type=template&id=6d24cec3&", function () {
      api.rerender('6d24cec3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Invitees/NoInviteesView.vue"
export default component.exports